import React from 'react'
import imgUrl from '/assets/images/team_logos/Barbarians.png';

export const Barbarians = ({width, height}) => {

    return (
        <img className={`max-h-[${height}px] max-h-200px max-w-[${width}px]`} src={imgUrl} alt="Barbarians"/>
    )
}